import { useLayoutEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { boardPollsActions } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/BoardPoll/boardPollsSagas'
import { POLL_KEY_ATTRIBUTE, isPollKey } from '@/shared/tools/communicationBoardPolls'

export interface PollTarget {
  id: string
  pollKey: string
  question: string
  element: HTMLElement
}

const QUESTION_ATTRIBUTE = 'data-poll-question'

// The widget replaces the placeholder's text, so the question is kept aside for the next pass (StrictMode).
const takeQuestion = (element: HTMLElement) => {
  const question = element.getAttribute(QUESTION_ATTRIBUTE) ?? (element.textContent ?? '').trim()
  element.setAttribute(QUESTION_ATTRIBUTE, question)
  element.textContent = ''
  return question
}

const pollTargetsIn = (container: HTMLElement): PollTarget[] =>
  [...container.querySelectorAll<HTMLElement>(`div[${POLL_KEY_ATTRIBUTE}]`)].flatMap((element, index) => {
    const pollKey = element.getAttribute(POLL_KEY_ATTRIBUTE)
    if (!isPollKey(pollKey)) return []

    return [{ id: `${pollKey}-${index}`, pollKey, question: takeQuestion(element), element }]
  })

const useBoardHtml = (html: string) => {
  const dispatch = useDispatch()
  const containerRef = useRef<HTMLDivElement>(null)
  const [targets, setTargets] = useState<PollTarget[]>([])

  useLayoutEffect(() => {
    const found = containerRef.current ? pollTargetsIn(containerRef.current) : []
    setTargets(found)
    if (found.length > 0) {
      dispatch({ type: boardPollsActions.LOAD_VOTES, pollKeys: [...new Set(found.map(target => target.pollKey))] })
    }
  }, [html, dispatch])

  return { containerRef, markup: { __html: html }, targets }
}

export default useBoardHtml
